export const BH_ROUTES = {
    BETA_HUB: "/beta-hub/",
    REGISTER: "/",
    PC_DOWNLOAD: "/download/",
    INVITE_BASE: "/invite/",
    OPT_IN_SUCCESS: "/opt-in-success/",
    BETA_HUB_REGISTERED: "/beta-hub-registered/",
    INVITEE_SUCCESS: "/invitee-success/",
    BETA_HUB_INVITEE_ACCEPTED: "/invitee-beta-hub-accepted/",
    BETA_HUB_ACCEPTED: "/beta-hub-accepted/",
    CONNECT_CONSOLE: "/connect-console/",
    BETA_HUB_INVITEE_COMPLETE: "/invitee-beta-hub-complete/",
    BETA_HUB_COMPLETE: "/beta-hub-complete/",
    ERROR_BASE: "/error",
    FAQ: "/faq/",
};
export const BETA_BASE_ROUTE = "";
export const ERROR_ROUTES = {
    INVITE_CLAIMED: `${BH_ROUTES.ERROR_BASE}/invite-claimed/`,
    MAX_REDEEMED: `${BH_ROUTES.ERROR_BASE}/max-redeemed/`,
    INVALID_LINK: `${BH_ROUTES.ERROR_BASE}/invalid-link/`,
    INVALID_PLATFORM: `${BH_ROUTES.ERROR_BASE}/invalid-platform/`,
    CAMPAIGN_INACTIVE: `${BH_ROUTES.ERROR_BASE}/campaign-inactive/`,
    UNAUTHORIZED: `${BH_ROUTES.ERROR_BASE}/unauthorized/`,
    UNAVAILABLE_REGION: `${BH_ROUTES.ERROR_BASE}/unavailable-region/`,
    GENERAL_ERROR: `${BH_ROUTES.ERROR_BASE}/general/`,
    NOT_ENTITLED: `${BH_ROUTES.ERROR_BASE}/not-entitled/`,
    RATE_LIMIT_ERROR: `${BH_ROUTES.ERROR_BASE}/rate-limit-error/`,
    ALREADY_REGISTERED: `${BH_ROUTES.ERROR_BASE}/already-registered/`,
    BETA_REGISTRATION_CLOSED: `${BH_ROUTES.ERROR_BASE}/registration-closed/`,
};
//# sourceMappingURL=constants.js.map